module.exports = __webpack_public_path__ + "static/media/banana_stuffed.d09f1d22.jpg";